import React from 'react';
import SelectInput from 'components/elements/Form/select/selectInput';
import SelectEntity from 'components/structure/Common/ListsEntity/SelectEntity';
import AccountService from 'services/hooks/account-service';

type RoleFieldsProps = {
  role: string;
  Controller: any;
  control: any;
  methods: any;
  buildingOptions: { value: string; label: string }[];
  orgOptions: { value: string; label: string }[];
  userRole?: string;
};

const AdminRoleFields: React.FC<RoleFieldsProps> = ({
  role,
  Controller,
  control,
  methods,
  buildingOptions,
  orgOptions,
  userRole
}) => {
  if (role === 'ACCOUNT') {
    return userRole === 'ACCOUNT' ? null : (
      <SelectEntity
        Controller={Controller}
        control={control}
        label="Choose an Account"
        placeholder="Select Account"
        queryname="accounts"
        name="accountUuid"
        defaultValue=""
        errors={methods.formState.errors}
        query={AccountService.findAllAccounts}
      />
    );
  } else if (role === 'BUILDING') {
    return (
      <>
        {userRole === 'ACCOUNT' ? null : (
          <SelectEntity
            Controller={Controller}
            control={control}
            label="Choose an Account"
            placeholder="Select Account"
            queryname="accounts"
            name="accountUuid"
            defaultValue=""
            errors={methods.formState.errors}
            query={AccountService.findAllAccounts}
          />
        )}
        <SelectInput
          Controller={Controller}
          control={control}
          label="Choose a Building"
          placeholder="Select Building"
          name="buildingUuid"
          errors={methods.formState.errors}
          options={buildingOptions}
        />
      </>
    );
  } else if (role === 'ORG') {
    return (
      <>
        {userRole === 'ACCOUNT' ? null : (
          <SelectEntity
            Controller={Controller}
            control={control}
            label="Choose an Account"
            placeholder="Select Account"
            queryname="accounts"
            name="accountUuid"
            defaultValue=""
            errors={methods.formState.errors}
            query={AccountService.findAllAccounts}
          />
        )}
        <SelectInput
          Controller={Controller}
          control={control}
          label="Choose a Building"
          placeholder="Select Building"
          name="buildingUuid"
          errors={methods.formState.errors}
          options={buildingOptions}
        />
        <SelectInput
          Controller={Controller}
          control={control}
          label="Choose an Organization"
          placeholder="Select Organization"
          errors={methods.formState.errors}
          name="organizationUuid"
          options={orgOptions}
        />
      </>
    );
  }
  return null;
};

export default AdminRoleFields;
